import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Divider } from '@mui/material';
import { Property } from '../../types/property.types';

interface SitePropertiesSectionProps {
  properties: Property[];
  sectionStyle: any;
}

const SitePropertiesSection: React.FC<SitePropertiesSectionProps> = ({ properties, sectionStyle }) => {
  if (!properties || properties.length === 0) {
    return null;
  }

  return (
    <Box mb={4} sx={sectionStyle}>
      <Typography 
        variant="h6" 
        gutterBottom 
        sx={{ 
          fontWeight: 600,
          fontSize: '1.25rem',
          mb: 3,
          color: '#1976d2'
        }}
      >
        This LOA relates to the following Sites
      </Typography>
      <List sx={{ p: 0 }}>
        {properties.map((property, index) => (
          <React.Fragment key={property._id || index}>
            <ListItem 
              alignItems="flex-start" 
              sx={{ 
                py: 2,
                px: 0,
                '&:hover': {
                  backgroundColor: 'rgba(25, 118, 210, 0.04)'
                }
              }}
            >
              <ListItemText
                primary={
                  <Typography 
                    variant="subtitle1" 
                    sx={{ 
                      fontWeight: 600,
                      color: '#1a1a1a',
                      mb: 0.5
                    }}
                  >
                    {property.name || 'Site Property'}
                  </Typography>
                }
                secondary={
                  <Typography 
                    component="div" 
                    variant="body2" 
                    sx={{ 
                      color: '#666',
                      lineHeight: 1.6
                    }}
                  >
                    {property.address.line1}
                    {property.address.line2 && `, ${property.address.line2}`}
                    <br />
                    {property.address.city}
                    {property.address.county && `, ${property.address.county}`}
                    <br />
                    {property.address.postcode}
                    {property.address.country && `, ${property.address.country}`}
                  </Typography>
                }
              />
            </ListItem>
            {index < properties.length - 1 && <Divider component="li" sx={{ my: 1 }} />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default SitePropertiesSection;
